import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { EventsDatas } from "./data";
import { useCmsSection } from "../../hooks/useCmsSection";
import { usePublicEvents, formatEventWhen } from "../../hooks/useDbEvents";
import BigImg from "../../assets/img/event/event-big.png";
import Iconclock from "../../assets/img/icon/clock.png";
import IconMap from "../../assets/img/icon/map.png";
import IconDate from "../../assets/img/icon/date.png";

function shortWhen(iso) {
  if (!iso) return { d: "—", m: "" };
  const x = new Date(iso);
  return { d: String(x.getDate()), m: x.toLocaleString(undefined, { month: "short" }) };
}

const STATIC_FEATURED = [
  {
    heading: "PCF family day — badminton, culture & integration fair",
    category: "#PCFCommunity",
    img: BigImg,
    para: `Badminton showcases, junior games, cultural stage, food, and integration & education info desks. Meet coaches, sign up for seasonal swim/cricket/football blocks, and celebrate together.`,
    IconClock: Iconclock,
    IconMap: IconMap,
    IconDate: IconDate,
    detailLink: "/event-details",
    locLabel: "Stockholm area (TBA)",
    timeLine: "10 am",
    dateBlock: { d: "20", m: "Dec" },
  },
];

const EventAreaPage = (props) => {
  const { events: dbEvents } = usePublicEvents();
  const { data: cmsEvents } = useCmsSection("events_list");

  const cmsSide = useMemo(() => {
    if (!Array.isArray(cmsEvents) || cmsEvents.length === 0) {
      return EventsDatas.map((item) => ({
        ...item,
        detailLink: "/event-details",
        locLabel: "Stockholm area (TBA)",
        timeLine: "10 am",
        dateBlock: { d: "20", m: "Dec" },
      }));
    }
    return cmsEvents.map((item) => ({
      heading: item.heading,
      category: item.category,
      para: item.para,
      IconClock: Iconclock,
      IconMap: IconMap,
      IconDate: IconDate,
      detailLink: "/event-details",
      locLabel: "Stockholm area (TBA)",
      timeLine: "10 am",
      dateBlock: { d: "20", m: "Dec" },
    }));
  }, [cmsEvents]);

  const dbSide = useMemo(
    () =>
      (dbEvents || []).map((ev) => ({
        id: ev.id,
        heading: ev.title,
        category: "#PCF",
        para:
          ev.summary ||
          (ev.body && ev.body.length > 220 ? `${ev.body.slice(0, 220)}…` : ev.body || ""),
        IconClock: Iconclock,
        IconMap: IconMap,
        IconDate: IconDate,
        detailLink: `/events/${ev.id}`,
        locLabel: ev.location || "TBA",
        timeLine: formatEventWhen(ev.starts_at, ev.ends_at),
        dateBlock: shortWhen(ev.starts_at),
        starts_at: ev.starts_at,
      })),
    [dbEvents]
  );

  const sideList = useMemo(() => {
    if (dbSide.length === 0) return cmsSide;
    const firstId = dbEvents[0]?.id;
    const restDb = firstId ? dbSide.filter((d) => d.id !== firstId) : dbSide;
    return [...restDb, ...cmsSide];
  }, [dbSide, cmsSide, dbEvents]);

  const featured = useMemo(() => {
    if (!dbEvents || dbEvents.length === 0) return STATIC_FEATURED;
    const ev = dbEvents[0];
    return [
      {
        heading: ev.title,
        category: "#Upcoming",
        img: ev.image_url || BigImg,
        para: ev.summary || ev.body?.slice(0, 400) || "",
        IconClock: Iconclock,
        IconMap: IconMap,
        IconDate: IconDate,
        detailLink: `/events/${ev.id}`,
        locLabel: ev.location || "TBA",
        timeLine: formatEventWhen(ev.starts_at, ev.ends_at),
        dateBlock: shortWhen(ev.starts_at),
      },
    ];
  }, [dbEvents]);

  return (
    <>
      <section
        id="upcoming_events"
        className={
          props.padding === true ? "section_padding" : "section_padding_bottom"
        }
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
              <div className="section_heading">
                <h3>Upcoming events</h3>
                <h2>
                  Join our next
                  <span className="color_big_heading">gatherings</span> in Sweden
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              {featured.map((data, index1) => (
                <div className="event_left_side_wrapper" key={index1}>
                  <div className="event_big_img">
                    <Link to={data.detailLink}>
                      <img src={data.img} alt="img" />
                    </Link>
                  </div>
                  <div className="event_content_area big_content_padding">
                    <div className="event_tag_area">
                      <Link to={data.detailLink}>{data.category}</Link>
                    </div>
                    <div className="event_heading_area">
                      <div className="event_heading">
                        <h3>
                          <Link to={data.detailLink}>{data.heading}</Link>
                        </h3>
                      </div>
                      <div className="event_date">
                        <img src={data.IconDate} alt="icon" />
                        <h6>
                          {data.dateBlock.d} <span>{data.dateBlock.m}</span>
                        </h6>
                      </div>
                    </div>
                    <div className="event_para">
                      <p>{data.para}</p>
                    </div>
                    <div className="event_boxed_bottom_wrapper">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                          <div className="event_bottom_boxed">
                            <div className="event_bottom_icon">
                              <img src={data.IconMap} alt="icon" />
                            </div>
                            <div className="event_bottom_content">
                              <h5>Location:</h5>
                              <p>{data.locLabel}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                          <div className="event_bottom_boxed">
                            <div className="event_bottom_icon">
                              <img src={data.IconClock} alt="icon" />
                            </div>
                            <div className="event_bottom_content">
                              <h5>When:</h5>
                              <p>{data.timeLine}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="event_button">
                      <Link to={data.detailLink} className="btn btn_md btn_theme">
                        View details
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-lg-6">
              {sideList.map((datas, indexs) => (
                <div
                  className="event_left_side_wrapper"
                  key={datas.id || `side-${indexs}`}
                >
                  <div className="event_content_area small_content_padding">
                    <div className="event_tag_area">
                      <Link to={datas.detailLink}>{datas.category}</Link>
                    </div>
                    <div className="event_heading_area">
                      <div className="event_heading">
                        <h3>
                          <Link to={datas.detailLink}>{datas.heading}</Link>
                        </h3>
                      </div>
                      <div className="event_date">
                        <img src={datas.IconDate} alt="icon" />
                        <h6>
                          {datas.dateBlock.d} <span>{datas.dateBlock.m}</span>
                        </h6>
                      </div>
                    </div>
                    <div className="event_para">
                      <p>{datas.para}</p>
                    </div>
                    <div className="event_boxed_bottom_wrapper">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                          <div className="event_bottom_boxed">
                            <div className="event_bottom_icon">
                              <img src={datas.IconMap} alt="icon" />
                            </div>
                            <div className="event_bottom_content">
                              <h5>Location:</h5>
                              <p>{datas.locLabel}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                          <div className="event_bottom_boxed">
                            <div className="event_bottom_icon">
                              <img src={datas.IconClock} alt="icon" />
                            </div>
                            <div className="event_bottom_content">
                              <h5>When:</h5>
                              <p>{datas.timeLine}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EventAreaPage;
